<template>
  <header :class="ceiling ? 'headerCeiling' : ''" class="headerBox">
    <div class="headerPC">
      <div>
        <div class="logo">
          <a href="/#/"><img src="../../assets/home/logo.png" /></a>
        </div>
        <ul class="menuNav">
          <li
            v-for="(item, index) in routerArr"
            :key="index"
            :class="getnum == index ? 'cur' : ''"
          >
            <router-link tag="a" :to="{ path: item.path }">{{
              item.name
            }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="headerPH">
      <div class="menuLogo" @click.stop="openMenu">
        <img src="@/assets/home/menu.png" />
      </div>
      <div class="logo">
        <a href="/#/"><img src="../../assets/home/logo.png" /></a>
      </div>
      <ul class="menuNav" v-show="menuShow">
        <li
          v-for="(item, index) in routerArr"
          :key="index"
          :class="getnum == index ? 'cur' : ''"
        >
          <router-link tag="a" :to="{ path: item.path }">{{
            item.name
          }}</router-link>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MainHeader",
  data() {
    return {
      routerArr: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "产品中心",
          path: "/productCenter",
        },
        {
          name: "解决方案",
          path: "/solution",
        },
        {
          name: "专题研究",
          path: "/researchConsulting",
        },
        {
          name: "会员服务",
          path: "/memberService",
        },
        {
          name: "关于我们",
          path: "/aboutUs",
        },
      ],
      ceiling: false,
      menuShow: false,
    };
  },
  computed: {
    ...mapGetters(["getnum"]),
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 88) {
        this.ceiling = true;
      } else {
        this.ceiling = false;
      }
    },
    openMenu() {
      this.menuShow = !this.menuShow;
    },
  },
  mounted() {
    let that = this;
    window.addEventListener("scroll", this.handleScroll);
    document.onclick = function () {
      if (that.menuShow == true) {
        that.menuShow = false;
      }
    };
  },
};
</script>

<style lang='scss' scoped>
@import './index';
</style>
